module.exports = __webpack_public_path__ + "img/nosotros-envases.b08be601.png";